import { gql } from "@/gql";

export const CONTRACTS_GLOBAL_SEARCH_QUERY = gql(`
  query ContractsGlobalSearch(
    $accountId: ID!
    $after: String
    $first: Int!
    $order: [ContractSortInput!]
    $where: ContractFilterInput
  ) {
    contractsV2(
      accountId: $accountId
      after: $after
      first: $first
      order: $order
      where: $where
    ) {
      totalCount
      nodes {
        id
        contractNumber
        customerName
        purchaseOrderNumber
        status
      }
    }
  }
`);

export const DEVICES_GLOBAL_SEARCH_QUERY = gql(`
  query DevicesGlobalSearch(
    $after: String
    $dealerAccountId: ID!
    $first: Int
    $initialise: Boolean!
    $order: [DealerDeviceSortInput!]
    $unassignedOnly: Boolean!
    $where: DealerDeviceFilterInput
  ) {
    dealerDevices(
      after: $after
      dealerAccountId: $dealerAccountId
      first: $first
      initialise: $initialise
      order: $order
      unassignedOnly: $unassignedOnly
      where: $where
    ) {
      totalCount
      nodes {
        id
        iconUrl
        modelName
        partNumber
        serialNumber
        ... on DealerDevice {
          reference
        }
      }
    }
  }
`);

export const DEALER_CUSTOMERS_GLOBAL_SEARCH_QUERY = gql(`
  query DealerCustomersGlobalSearch($accountId: ID!) {
    dealerCustomers(accountId: $accountId) {
      id
      companyName
      users {
        ... on User {
          id
          email
          firstName
          lastName
          role
          status
        }
        ... on PendingUser {
          id
          email
          role
        }
      }
    }
  }
`);

export const INVOICES_GLOBAL_SEARCH_QUERY = gql(`
    query InvoicesGlobalSearch(
      $after: String,
      $before: String, $dealerAccountId: String!, $first: Int, $last: Int,
      $order: [DealerInvoiceSortInput!], $where: DealerInvoiceFilterInput
    ) {
      dealerInvoices(
        after: $after,
        before: $before, dealerAccountId: $dealerAccountId, first: $first, last: $last, order: $order, where: $where
      ) {
        totalCount
        nodes {
          id
          createdDate
          contract {
            id
            contractNumberSearch
            customerName
            purchaseOrderNumber
          }
        }
      }
    }
  `);
